const NAMESPACE = 'notification';
export const SET = `${NAMESPACE}/set`;
